module.exports = __webpack_public_path__ + "static/media/design-denim.83c20878.svg";